import React, { useMemo } from "react";
import styles from "./styles.module.scss";
import { InputSearch } from "../../../../../../../boxes/InputSearch/InputSearch";
import { DateRangePicker } from "../../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { Button } from "../../../../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { useCurrentAccountQuery } from "../../../../../../../api/queries/useAccountQuery";
import { apiDateStringToDate } from "../../../../../../../utilities/api";
import { squashSpaces } from "../../../../../../../utilities/general";
import { Select } from "../../../../../../../shared/Select/Select";

export const TableHeading = ({ isReportsLoading, period, search, clinic }) => {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { data: user } = useCurrentUserQuery();
  const { data: account, isLoading: isAccountLoading } =
    useCurrentAccountQuery();

  const clinicOptions = useMemo(() => {
    const allClinicsOption = {
      label: tBi("shortTermLiabilityReport.filter.allClinics"),
      value: null,
    };

    const options = (clinic?.options || []).map((c) => ({
      label: c.name,
      value: c.id,
    }));

    return [allClinicsOption, ...options];
  }, [clinic?.options, tBi]);

  const selectedClinic = useMemo(() => {
    return (
      clinicOptions.find((opt) => opt.value === clinic?.value) ||
      clinicOptions[0]
    );
  }, [clinicOptions, clinic?.value]);

  return (
    <div className={styles.root}>
      <InputSearch value={search.value} onChange={search.onChange} />
      <Select
        size="small"
        value={selectedClinic}
        onChange={(option) => clinic?.onChange(option?.value || null)}
        options={clinicOptions}
        isDisabled={isReportsLoading}
        className={styles.clinicsSelect}
      />
      <DateRangePicker
        isDisabled={isReportsLoading}
        size="small"
        dateFormat={user?.dateFormat}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
      <Button
        size="small"
        variant="outlined"
        isDisabled={isAccountLoading || !account.createdAt}
        onClick={() =>
          period.update({
            from: apiDateStringToDate(
              squashSpaces(account.createdAt).split(" ")[0],
            ),
            to: new Date(),
          })
        }
      >
        {tBi("shortTermLiabilityReport.allTimePeriod")}
      </Button>
    </div>
  );
};
